
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"

// small button rendered inside a row's label, to the right
export interface DetailRowAction {
  key: string
  label: string
  tooltip: string
}
export interface DetailRow {
  // identifies the row to the parent (e.g. which field an action belongs to)
  id?: string
  label: string
  actions?: Array<DetailRowAction>
  value: string | null
  small?: boolean
  mono?: boolean
}

// renders a set of label/value pairs as a responsive 4/2 column grid - used
// both for the MemberDetailDialog overview row and each collapsible section
@Component
export default class DetailGrid extends Vue {
  @Prop()
  rows: Array<DetailRow>

  // the overview row uses slightly different spacing to the sections below
  @Prop({default: false})
  overview: boolean
}
